/**
 * Import Dependency
 */
import Vue from "vue";
import VueCookie from "vue-cookie";
import axios from "./interceptor";
import { baseUrl, routes } from "./config";

Vue.use(VueCookie);
let token = VueCookie.get("token");
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

/**
 * Export
 */
export default {
  login(data) {
    delete axios.defaults.headers.common.Authorization;
    return axios.post(`${baseUrl}${routes.auth}`, data);
  },
  logout() {
    return axios.delete(`${baseUrl}${routes.auth}`);
  },
  getUserList(req) {
    // let token = VueCookie.get("token");
    // axios.defaults.headers.common["Content-Type"] = "application/json";
    // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return axios({
      method: "get",
      url: `${baseUrl}${routes.users}`,
      params: req
    }).then(res => {
      return res.data.data;
    });
  },
  getUserListLength() {
    return axios(`${baseUrl}${routes.users}/count`).then(res => {
      return res.data;
    });
  },
  getSingleUser(id) {
    return axios(`${baseUrl}${routes.users}/${id}`).then(res => {
      return res.data.data;
    });
  },
  addUser(data) {
    return axios.post(`${baseUrl}${routes.users}`, data).then(res => {
      return res.data.data;
    });
  },
  editUser(data, index) {
    return axios.patch(`${baseUrl}${routes.users}/${index}`, data).then(res => {
      return res.data.data;
    });
  },
  deleteUser(id) {
    return axios.delete(`${baseUrl}${routes.users}/${id}`).then(res => {
      return res;
    });
  },
  editUserCashBag(data, id) {
    return axios
      .patch(`${baseUrl}${routes.users}/${id}/cashbag`, data)
      .then(res => {
        return res.data.data;
      });
  },
  getPaymentRevenue(data) {
    return axios({
      method: "get",
      url: `${baseUrl}${routes.revenue}`,
      params: data
    }).then(res => {
      return res.data.data;
    });
  },
  getReceiveRevenue(data) {
    return axios({
      method: "get",
      url: `${baseUrl}${routes.revenue}${routes.orders}`,
      params: data
    }).then(res => {
      return res.data.data;
    });
  },
  addPaymentRevenue(data) {
    return axios.post(`${baseUrl}${routes.revenue}`, data).then(res => {
      return res.data;
    });
  },
  editPaymentRevenue(data, id) {
    return axios.patch(`${baseUrl}${routes.revenue}/${id}`, data).then(res => {
      return res.data;
    });
  },
  deletePaymentRevenue(id) {
    return axios.delete(`${baseUrl}${routes.revenue}/${id}`).then(res => {
      return res.data.data;
    });
  },
  getTodayOrderList(date) {
    return axios({
      method: "get",
      url: `${baseUrl}${routes.orders}`,
      params: date
    }).then(res => {
      return res.data.data;
    });
  },
  getWeekOrder(date, id) {
    return axios({
      method: "get",
      url: `${baseUrl}${routes.orders}/week/${id}`,
      params: date
    }).then(res => {
      return res.data.data;
    });
  },
  addOrder(data) {
    return axios.post(`${baseUrl}${routes.orders}`, data).then(res => {
      return res;
    });
  },
  editOrder(id, data) {
    return axios.patch(`${baseUrl}${routes.orders}/${id}`, data).then(res => {
      return res.data.data;
    });
  },
  deleteOrder(id) {
    return axios.delete(`${baseUrl}${routes.orders}/${id}`).then(res => {
      return res.data.data;
    });
  },
  editBag(id) {
    return axios.patch(`${baseUrl}${routes.orders}/${id}/bag`).then(res => {
      return res.data.data;
    });
  },
  getUserOrderInMonth(id, date) {
    return axios({
      method: "get",
      url: `${baseUrl}${routes.orders}/user/${id}`,
      params: date
    }).then(res => {
      return res.data.data;
    });
  },
  getOrderTotalList(date) {
    return axios({
      method: "get",
      url: `${baseUrl}${routes.orders}/total`,
      params: date
    }).then(res => {
      return res.data.data;
    });
  },
  updateToken() {
    let token = VueCookie.get("token");
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
};
